import React from "react";
import { useNavigate } from "react-router-dom";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import FormAddEditPage from "../../components/pages_cms/FormAddEditPage";

const CreatePage = () => {
    const navigate = useNavigate();

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditPage
                isEdit={false}
                onSubmitSuccess={() => navigate("/pages")}
            />
        </WrapperSection>
    );
};

export default CreatePage;
